import * as React from 'react';

import { Box, BoxOwnProps } from '../Box';

export const PanelContent: React.FC<BoxOwnProps> = ({ children, ...props }) => (
  <Box p={4} className="sl-panel__content" {...props}>
    {children}
  </Box>
);
